module.exports = __webpack_public_path__ + "static/media/blue-plus-ic.62bf0616.svg";